import Repository from './Repository';
const resource = '/movie';

export default {
  get(id) {
    return Repository.get(`${resource}/${id}`);
  }
};
